import get from "lodash/get";
import { getLatestUserCookie } from "../components/Login/user_session";
import { fetchData } from "./fetchData";
export var saveVenuesApi = function saveVenuesApi(sitecoreContext, ids) {
  return getLatestUserCookie().then(function (userCookie) {
    if (userCookie.login_status && !userCookie.error) {
      var apiGlobal = get(sitecoreContext, 'configuration.globalApi.apiGlobal') || 'replaceGlobal';
      return fetchData({
        path: "".concat(apiGlobal, "/graphql/user"),
        options: {
          method: 'POST',
          body: JSON.stringify({
            query: "mutation addVenues {\n                            addVenues(venueIds:[".concat(ids.map(function (id) {
              return "\"".concat(id, "\"");
            }).join(', '), "]) {\n                                venueId,\n                                created\n                            }\n                        }")
          })
        },
        authToken: userCookie.access_token
      });
    }
  });
};
export var deleteVenuesApi = function deleteVenuesApi(sitecoreContext, ids) {
  return getLatestUserCookie().then(function (userCookie) {
    if (userCookie.login_status && !userCookie.error) {
      var apiGlobal = get(sitecoreContext, 'configuration.globalApi.apiGlobal') || 'replaceGlobal';
      return fetchData({
        path: "".concat(apiGlobal, "/graphql/user"),
        options: {
          method: 'POST',
          body: JSON.stringify({
            query: "mutation deleteVenues {\n                            deleteVenues(venueIds:[".concat(ids.map(function (id) {
              return "\"".concat(id, "\"");
            }).join(', '), "]) {\n                                venueId,\n                                created\n                            }\n                        }")
          })
        },
        authToken: userCookie.access_token
      });
    }
  });
};
export var getVenuesApi = function getVenuesApi(sitecoreContext) {
  return getLatestUserCookie().then(function (userCookie) {
    if (userCookie.login_status && !userCookie.error) {
      var apiGlobal = get(sitecoreContext, 'configuration.globalApi.apiGlobal') || 'replaceGlobal';
      return fetchData({
        path: "".concat(apiGlobal, "/graphql/user"),
        options: {
          method: 'POST',
          body: JSON.stringify({
            query: "{ user {\n                            venues {\n                                venueId,\n                                created\n                            }\n                        }}"
          })
        },
        authToken: userCookie.access_token
      });
    }
  });
};